<template>
    <div>
        <CRow>
            <CCol>
                <ejs-grid ref='grid'
                          :dataSource='deadlineData'
                          :allowFiltering='true'
                          :allowPaging='true'
                          :allowResizing='true'
                          :allowReordering='true'
                          :allowSorting='true'
                          :toolbar='toolbar'
                          :editSettings='editSettings'
                          :pageSettings='pageSettings'
                          :filterSettings='filterOptions'
                          :toolbarClick='toolbarClick'
                          :allowExcelExport='true'
                          :excelExportComplete='excelExportComplete'
                          :query='gridQuery'
                          :actionComplete="actionComplete"
                          :actionBegin="actionBegin">
                    <e-columns>                       
                        <e-column field='id' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='contractTradeablePeriodId' headerText='ContractTradeablePeriod' :visible='false'></e-column>
                        <e-column field='tradablePeriod' headerText='Tradable Period' width=120 :allowEditing="false"></e-column>
                        <e-column field='deadlineDate' headerText='Deadline Date' :format='dateFormatOptions' type='date' :edit="dpParams" width=120></e-column>
                    </e-columns>
                </ejs-grid>
                <div id="modalTarget" class="control-section; position:relative" style="height:350px;">
                    <ejs-uploader ref="uploadObj" id='defaultfileupload' name="uploadFile" :allowedExtensions="extensions" :uploading="addHeaders" :asyncSettings="path" :success="onUploadSuccess" :failure="onUploadFailed" :multiple='multiple'></ejs-uploader>
                </div>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DropDownListPlugin, MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { UploaderPlugin } from "@syncfusion/ej2-vue-inputs";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import SyncHelper from '../../common/syncfusion'
    import gridOptions from '../../common/gridOptions'
    import store from '../../store';
    import { Query } from '@syncfusion/ej2-data'
    import apis from '../../common/network'
    import urls from '../../common/urls'
    import authToken from '../../common/authToken';


    Vue.use(GridPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DatePickerPlugin);

    let datePickerObj, elem;
    export default {
        name: 'DefaultDeadlineForm',
        created() {
        },
        data() {
            return {
                deadlineData: SyncHelper.getDataManager("defaultdeadline"),
                pageSettings: gridOptions.pageSettings,
                gridQuery: new Query().addParams("contractId", store.state.selectedContractId),
                maxDeadlineDate: null,
                editSettings: {
                    showConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.DefaultDeadline.Update"],
                    mode: 'Normal'
                },
                toolbar: ['Edit', 'ExcelExport'],
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy' },
                path: {
                    saveUrl: `${urls.apiBaseUrl}defaultdeadline/import?contractId=${store.state.selectedContractId}`
                },
                extensions: ' .xls, .xlsx',
                multiple: false,
                addHeaders: function (args) {
                    args.currentRequest.setRequestHeader('Authorization', `Bearer ${authToken.get()}`);
                },
                dpParams: {
                    create: function () {
                        elem = document.createElement('input');
                        return elem;
                    },
                    read: () => {
                        return datePickerObj.value;
                    },
                    destroy: () => {
                        datePickerObj.destroy();
                    },
                    write: (args) => {
                        datePickerObj = new DatePicker({
                            value: args.rowData[args.column.field] ? new Date(args.rowData[args.column.field]): null,
                            floatLabelType: 'Always',
                            format: 'dd/MM/yyyy',
                            min: new Date(),
                            placeholder: 'Settlement Date',
                            firstDayOfWeek: 1,
                        });
                        datePickerObj.appendTo(elem);
                    }
                },
            }
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.grid.getColumns()[0].visible = true;
                }
                gridOptions.excelExport(args, "ProductExpiryAlert.xlsx", this.$refs);
            },
            fixDateOffset: function (date) {
                date.setHours(date.getHours() - (date.getTimezoneOffset() / 60));
                return date;
            },
            excelExportComplete(args) {
                this.$refs.grid.getColumns()[0].visible = false;
                this.$refs.grid.hideSpinner();
            },
            actionBegin(args) {
                if (args.requestType === 'beginEdit') {
   
                    apis.protectedApi(`${urls.apiBaseUrl}ContractTrigger/PeriodDeadline/${args.rowData.contractTradeablePeriodId}`).then(it => {
                        const [day, month, year] = it.data.lastDay.split('/');

                        const maxDate = new Date(
                            Number(year),
                            Number(month) - 1,
                            Number(day)
                        );

                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        // historijski period
                        if (maxDate < today) {

                            gridOptions.errorAlert(
                                `${args.rowData.tradablePeriod} period can no longer be edited.`
                            );

                            this.$refs.grid.closeEdit();
                            return;
                        }

                        datePickerObj.max = maxDate;
                        datePickerObj.dataBind();

                            // datePickerObj.max = new Date(it.data.lastDay);

                    }).catch(
                        response => {
                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                            gridOptions.errorAlert("Error: " + message);
                        }
                    );
                }
                if (args.requestType === 'save') {
                    if (datePickerObj.value) {
                        args.data.deadlineDate =
                            this.fixDateOffset(datePickerObj.value);
                    }

                    if (!datePickerObj.value || !datePickerObj.max) {
                        return;
                    }

                    const selectedDate = new Date(datePickerObj.value);
                    selectedDate.setHours(0, 0, 0, 0);

                    const maxDate = new Date(datePickerObj.max);
                    maxDate.setHours(0, 0, 0, 0);

                    if (selectedDate > maxDate) {

                        gridOptions.errorAlert(
                            `Date must be before the start of the ${args.data.tradablePeriod} period.`
                        );

                        args.cancel = true;
                        return;
                    }
                    
                    
                }
            },
            actionComplete(args) {
                if (args.requestType === 'save') {
                    this.$refs.grid.refresh();
                }
            },
            onUploadFailed: function (args) {
                this.$refs.grid.refresh();
                var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                args.statusText = statusMessage.trim();
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            },
            onUploadSuccess: function (args) {
                if (JSON.parse(args.e.currentTarget.response).status === "OK with Errors") {
                    let fileName = JSON.parse(args.e.currentTarget.response).file.fileDownloadName;
                    let base64String = JSON.parse(args.e.currentTarget.response).file.fileContents;
                    const byteCharacters = atob(base64String);
                    const byteNumbers = new Uint8Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }

                    const blob = new Blob([byteNumbers], { type: 'application/octet-stream' });
                    const url = window.URL.createObjectURL(blob);
                    const element = document.createElement('a');
                    element.href = url;
                    element.download = fileName;
                    document.body.appendChild(element);
                    element.click();
                    element.remove();
                    window.URL.revokeObjectURL(url);
                    var statusMessage = JSON.parse(args.e.currentTarget.response).message;
                    args.statusText = statusMessage.trim();
                }
                this.$refs.grid.refresh();
            },
        },
        computed: {
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style scoped>
</style>